import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { PAGE } from "components/common/CONSTANTS";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { RESET_PO_AMEND_PATCH } from "../../redux/actions/action-type";

export const ConfirmationDialog = ({
  dialogOpen,
  setDialogOpen,
  isSaved,
  setIsSaved,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    setIsSaved(false);
    setDialogOpen(false);
    dispatch({ type: RESET_PO_AMEND_PATCH });
    navigate(PAGE.PO_SUMMARY.url, {
      state: {
        retainSearchCriteria: true,
      },
    });
  };

  return (
    <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
      <div className="dialogStyling">
        <DialogTitle>
          {!isSaved && <>PO Amend Confirmation</>}
          {isSaved && <>PO Saved</>}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {!isSaved && <>POs have been successfully amended.</>}
            {isSaved && <>POs have been successfully saved.</>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="commonPOButtons"
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            OK
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
